import { OperatorCapability } from './operator-capability';

export class Operator {
  constructor(
    public hash?: string,
    public code?: string,
    public name?: string,
    public active?: boolean,
    public workingModelGroupHash?: string,
    public workingModelGroupName?: string,
    public operatorGroupHash?: string,
    public operatorGroupName?: string,
    public capabilities?: OperatorCapability[],
  ) { }

  clone() {
    return new Operator(
      this.hash,
      this.code,
      this.name,
      this.active,
      this.workingModelGroupHash,
      this.workingModelGroupName,
      this.operatorGroupHash,
      this.operatorGroupName,
      this.capabilities,
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/operator.ts